// extracted by mini-css-extract-plugin
export var buttonPlay = "ReviewInfo-module--buttonPlay--4cb93";
export var card = "ReviewInfo-module--card--e6358";
export var dynamicMobileHeight = "ReviewInfo-module--dynamicMobileHeight--e0c7c";
export var fadeInAnimation = "ReviewInfo-module--fadeInAnimation--7043c";
export var link = "ReviewInfo-module--link--56088";
export var logo = "ReviewInfo-module--logo--14de6";
export var logoWrapper = "ReviewInfo-module--logoWrapper--d4e13";
export var mediaPlayer = "ReviewInfo-module--mediaPlayer--512d8";
export var poster = "ReviewInfo-module--poster--f8518";
export var posterWrapper = "ReviewInfo-module--posterWrapper--d8d99";
export var review = "ReviewInfo-module--review--442fa";
export var section = "ReviewInfo-module--section--eb915";
export var text = "ReviewInfo-module--text--276bf";
export var withVideo = "ReviewInfo-module--withVideo--61ff2";
export var wrapper = "ReviewInfo-module--wrapper--76b3c";